<script>
  import {cn} from "../../utils.js";
  import GridHead from "./bits/calendar-grid-head.svelte";

  let {ref = $bindable(null), class: className, ...restProps} = $props();
</script>

<GridHead bind:ref class={cn(className)} {...restProps}/>
